module.exports = __webpack_public_path__ + "img/sunrise_preview.d68e70ee.jpg";